import { render, staticRenderFns } from "./input.vue?vue&type=template&id=3835ec6c&scoped=true&lang=pug&"
import script from "./input.vue?vue&type=script&lang=js&"
export * from "./input.vue?vue&type=script&lang=js&"
import style0 from "./input.vue?vue&type=style&index=0&id=3835ec6c&prod&lang=scss&"
import style1 from "./input.vue?vue&type=style&index=1&id=3835ec6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3835ec6c",
  null
  
)

/* custom blocks */
import block0 from "~/lang/formFields?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fubuntu%2Fnuxt%2Fbonkers%2Freleases%2F20230609154748%2Fcomponents%2Fwidgets%2Fforms%2Finput.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WidgetsFormsRadio: require('/home/ubuntu/nuxt/bonkers/releases/20230609154748/components/widgets/forms/radio.vue').default,WidgetsFormsRadioGroup: require('/home/ubuntu/nuxt/bonkers/releases/20230609154748/components/widgets/forms/radio-group.vue').default,WidgetsFormsRadioGrid: require('/home/ubuntu/nuxt/bonkers/releases/20230609154748/components/widgets/forms/radio-grid.vue').default,WidgetsFormsSelect: require('/home/ubuntu/nuxt/bonkers/releases/20230609154748/components/widgets/forms/select.vue').default,WidgetsFormsMoney: require('/home/ubuntu/nuxt/bonkers/releases/20230609154748/components/widgets/forms/money.vue').default,WidgetsFormsCustomerDob: require('/home/ubuntu/nuxt/bonkers/releases/20230609154748/components/widgets/forms/customer/dob.vue').default})
